/* tslint:disable */
/* eslint-disable */
/**
 * KNMI exons API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { BaseError } from '../types';
// @ts-ignore
import type { LegacyWarningSetting } from '../types';
// @ts-ignore
import type { LegacyWarningsData } from '../types';
// @ts-ignore
import type { UpdateLegacyWarningSettingBody } from '../types';
// @ts-ignore
import type { ValidationError } from '../types';
/**
 * LegacyWarningsApi - axios parameter creator
 * @export
 */
export const LegacyWarningsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns LegacyWarningSettings for a Dashboard.
         * @summary Get LegacyWarningSettings for Dashboard by ID
         * @param {string} dashboardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLegacyWarningSettingsForDashboard: async (dashboardId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dashboardId' is not null or undefined
            assertParamExists('getLegacyWarningSettingsForDashboard', 'dashboardId', dashboardId)
            const localVarPath = `/dashboards/{dashboard_id}/legacy_warning_settings`
                .replace(`{${"dashboard_id"}}`, encodeURIComponent(String(dashboardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Shows the data based on legacy warnings settings for a published Dashboard.
         * @summary Show legacy warnings data for published Dashboard
         * @param {string} dashboardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLegacyWarningsDataForPublishedDashboard: async (dashboardId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dashboardId' is not null or undefined
            assertParamExists('getLegacyWarningsDataForPublishedDashboard', 'dashboardId', dashboardId)
            const localVarPath = `/published/dashboards/{dashboard_id}/legacy_warnings_data`
                .replace(`{${"dashboard_id"}}`, encodeURIComponent(String(dashboardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates LegacyWarningSettings.
         * @summary Update LegacyWarningSettings for Dashboard by ID
         * @param {string} dashboardId 
         * @param {UpdateLegacyWarningSettingBody} [updateLegacyWarningSettingBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLegacyWarningSettings: async (dashboardId: string, updateLegacyWarningSettingBody?: UpdateLegacyWarningSettingBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dashboardId' is not null or undefined
            assertParamExists('updateLegacyWarningSettings', 'dashboardId', dashboardId)
            const localVarPath = `/dashboards/{dashboard_id}/legacy_warning_settings`
                .replace(`{${"dashboard_id"}}`, encodeURIComponent(String(dashboardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateLegacyWarningSettingBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LegacyWarningsApi - functional programming interface
 * @export
 */
export const LegacyWarningsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LegacyWarningsApiAxiosParamCreator(configuration)
    return {
        /**
         * Returns LegacyWarningSettings for a Dashboard.
         * @summary Get LegacyWarningSettings for Dashboard by ID
         * @param {string} dashboardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLegacyWarningSettingsForDashboard(dashboardId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LegacyWarningSetting>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLegacyWarningSettingsForDashboard(dashboardId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LegacyWarningsApi.getLegacyWarningSettingsForDashboard']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Shows the data based on legacy warnings settings for a published Dashboard.
         * @summary Show legacy warnings data for published Dashboard
         * @param {string} dashboardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLegacyWarningsDataForPublishedDashboard(dashboardId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LegacyWarningsData>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLegacyWarningsDataForPublishedDashboard(dashboardId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LegacyWarningsApi.getLegacyWarningsDataForPublishedDashboard']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Updates LegacyWarningSettings.
         * @summary Update LegacyWarningSettings for Dashboard by ID
         * @param {string} dashboardId 
         * @param {UpdateLegacyWarningSettingBody} [updateLegacyWarningSettingBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateLegacyWarningSettings(dashboardId: string, updateLegacyWarningSettingBody?: UpdateLegacyWarningSettingBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LegacyWarningSetting>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateLegacyWarningSettings(dashboardId, updateLegacyWarningSettingBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LegacyWarningsApi.updateLegacyWarningSettings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * LegacyWarningsApi - factory interface
 * @export
 */
export const LegacyWarningsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LegacyWarningsApiFp(configuration)
    return {
        /**
         * Returns LegacyWarningSettings for a Dashboard.
         * @summary Get LegacyWarningSettings for Dashboard by ID
         * @param {string} dashboardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLegacyWarningSettingsForDashboard(dashboardId: string, options?: RawAxiosRequestConfig): AxiosPromise<LegacyWarningSetting> {
            return localVarFp.getLegacyWarningSettingsForDashboard(dashboardId, options).then((request) => request(axios, basePath));
        },
        /**
         * Shows the data based on legacy warnings settings for a published Dashboard.
         * @summary Show legacy warnings data for published Dashboard
         * @param {string} dashboardId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLegacyWarningsDataForPublishedDashboard(dashboardId: string, options?: RawAxiosRequestConfig): AxiosPromise<LegacyWarningsData> {
            return localVarFp.getLegacyWarningsDataForPublishedDashboard(dashboardId, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates LegacyWarningSettings.
         * @summary Update LegacyWarningSettings for Dashboard by ID
         * @param {string} dashboardId 
         * @param {UpdateLegacyWarningSettingBody} [updateLegacyWarningSettingBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLegacyWarningSettings(dashboardId: string, updateLegacyWarningSettingBody?: UpdateLegacyWarningSettingBody, options?: RawAxiosRequestConfig): AxiosPromise<LegacyWarningSetting> {
            return localVarFp.updateLegacyWarningSettings(dashboardId, updateLegacyWarningSettingBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LegacyWarningsApi - object-oriented interface
 * @export
 * @class LegacyWarningsApi
 * @extends {BaseAPI}
 */
export class LegacyWarningsApi extends BaseAPI {
    /**
     * Returns LegacyWarningSettings for a Dashboard.
     * @summary Get LegacyWarningSettings for Dashboard by ID
     * @param {string} dashboardId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LegacyWarningsApi
     */
    public getLegacyWarningSettingsForDashboard(dashboardId: string, options?: RawAxiosRequestConfig) {
        return LegacyWarningsApiFp(this.configuration).getLegacyWarningSettingsForDashboard(dashboardId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Shows the data based on legacy warnings settings for a published Dashboard.
     * @summary Show legacy warnings data for published Dashboard
     * @param {string} dashboardId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LegacyWarningsApi
     */
    public getLegacyWarningsDataForPublishedDashboard(dashboardId: string, options?: RawAxiosRequestConfig) {
        return LegacyWarningsApiFp(this.configuration).getLegacyWarningsDataForPublishedDashboard(dashboardId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates LegacyWarningSettings.
     * @summary Update LegacyWarningSettings for Dashboard by ID
     * @param {string} dashboardId 
     * @param {UpdateLegacyWarningSettingBody} [updateLegacyWarningSettingBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LegacyWarningsApi
     */
    public updateLegacyWarningSettings(dashboardId: string, updateLegacyWarningSettingBody?: UpdateLegacyWarningSettingBody, options?: RawAxiosRequestConfig) {
        return LegacyWarningsApiFp(this.configuration).updateLegacyWarningSettings(dashboardId, updateLegacyWarningSettingBody, options).then((request) => request(this.axios, this.basePath));
    }
}

